import { TaskPriority, TaskStatus, TaskType } from '../domain/types';

export const taskTypeLabels: Record<TaskType, string> = {
  [TaskType.OTHER]: 'Altro',
};

export const taskPriorityLabels: Record<TaskPriority, string> = {
  [TaskPriority.LOW]: 'Bassa',
  [TaskPriority.MEDIUM]: 'Media',
  [TaskPriority.HIGH]: 'Alta',
};

export const taskStatusLabels: Record<TaskStatus, string> = {
  [TaskStatus.TODO]: 'Da fare',
  [TaskStatus.IN_PROGRESS]: 'In corso',
  [TaskStatus.DONE]: 'Completata',
};
